import React from "react"

import { ChatBotFlowBlockRule } from "@/protocols/chatBot"

import GenericConditionSectionContainer from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/GenericConditionSectionContainer"
import ContrastChip from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/ContrastChip"

import { colors } from "@/styles/colors"

type AIConditionSectionContainerProps = {
	chatBotFlowBlockRule: ChatBotFlowBlockRule
	chatBotFlowBlockId: number
}

const AIConditionSectionContainer: React.FC<AIConditionSectionContainerProps> = (props) => {
	const {
		chatBotFlowBlockRule,
		chatBotFlowBlockId
	} = props

	return (
		<GenericConditionSectionContainer
			chatBotFlowBlockRule={chatBotFlowBlockRule}
			customValidationRender={{
				"ai-condition-match": {
					firstItem: {
						render: () => (
							<ContrastChip
								title="Mensagem recebida"
								backgroundColor={colors.blue[200]}
							/>
						)
					},
					secondItem: {
						render: ({ validation }) => (
							<ContrastChip
								title={validation.extra_data?.ai_condition?.title}
								backgroundColor={colors.blue[400]}
							/>
						)
					},
					comparisonItem: {
						render: () => (
							<ContrastChip
								title="Representa"
								backgroundColor={colors.blue[200]}
							/>
						)
					}
				}
			}}
			chatBotFlowBlockId={chatBotFlowBlockId}
		/>
	)
}

export default AIConditionSectionContainer
